"use client";

import { IconLoader } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import * as React from "react";
import { SiteCustomizationPage } from "@/features/site-customization/components/site-customization-page";
import { metadataToHomeSectionsForm } from "@/features/site-customization/lib/metadata-to-form";
import { useStoreDetails } from "@/features/store-settings/hooks/use-store-details";
import { useStoreSlug } from "@/hooks/use-store-slug";
import { useStores } from "@/hooks/use-stores";

export const Route = createFileRoute("/$store/_layout/site-customization")({
	component: SiteCustomizationRoute,
});

function SiteCustomizationRoute() {
	const storeSlug = useStoreSlug();
	const { stores, isLoading } = useStores();
	const { storeDetails, isLoading: isLoadingDetails } = useStoreDetails();

	const currentStore = React.useMemo(() => {
		if (!storeSlug) return null;
		return stores.find((store) => store.slug === storeSlug) || null;
	}, [storeSlug, stores]);

	const initialHomeSections = React.useMemo(
		() =>
			metadataToHomeSectionsForm(
				storeDetails?.metadata as Record<string, unknown> | undefined,
			),
		[storeDetails],
	);

	if (isLoading || isLoadingDetails) {
		return (
			<div className="flex items-center justify-center h-64">
				<IconLoader className="size-6 animate-spin text-muted-foreground" />
			</div>
		);
	}

	if (!currentStore) {
		return (
			<div className="flex items-center justify-center h-64">
				<p className="text-muted-foreground">Loja não encontrada.</p>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-6 px-4 py-6 lg:px-6">
			<div>
				<h1 className="text-2xl font-semibold text-foreground">
					Personalizar site
				</h1>
				<p className="text-sm text-muted-foreground">
					Habilite seções de conteúdo na sua home e cadastre as informações.
					Cada bloco ativo melhora o conteúdo indexável e o SEO da loja.
				</p>
			</div>

			<SiteCustomizationPage initialHomeSections={initialHomeSections} />
		</div>
	);
}
